import text from "./solomon-main-app-2026-01-24.md?raw";

export interface SolomonTermsDescriptor {
    readonly documentKey: string;
    readonly version: string;
    readonly contentDigest: `sha256:${string}`;
    readonly text: string;
}

export const solomonMainAppTerms: SolomonTermsDescriptor = Object.freeze({
    documentKey: "solomon-main-app",
    version: "2026-01-24",
    contentDigest: "sha256:40aef842ac7732a03965d0d53b497dbb287538a33b3682dbd9b4f0f37d8c034e",
    text
});
